var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShops(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2100_10361",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2100_10361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 18.3333C3.70833 18.3333 3.31597 18.1701 2.98958 17.8437C2.66319 17.5173 2.5 17.1249 2.5 16.6666V6.66658C2.5 6.20825 2.66319 5.81589 2.98958 5.4895C3.31597 5.16311 3.70833 4.99992 4.16667 4.99992H5.83333C5.83333 3.84714 6.23958 2.8645 7.05208 2.052C7.86458 1.2395 8.84722 0.833252 10 0.833252C11.1528 0.833252 12.1354 1.2395 12.9479 2.052C13.7604 2.8645 14.1667 3.84714 14.1667 4.99992H15.8333C16.2917 4.99992 16.684 5.16311 17.0104 5.4895C17.3368 5.81589 17.5 6.20825 17.5 6.66658V16.6666C17.5 17.1249 17.3368 17.5173 17.0104 17.8437C16.684 18.1701 16.2917 18.3333 15.8333 18.3333H4.16667ZM4.16667 16.6666H15.8333V6.66658H4.16667V16.6666ZM10 11.6666C11.1528 11.6666 12.1354 11.2603 12.9479 10.4478C13.7604 9.63533 14.1667 8.6527 14.1667 7.49992H12.5C12.5 8.19436 12.2569 8.78464 11.7708 9.27075C11.2847 9.75686 10.6944 9.99992 10 9.99992C9.30556 9.99992 8.71528 9.75686 8.22917 9.27075C7.74306 8.78464 7.5 8.19436 7.5 7.49992H5.83333C5.83333 8.6527 6.23958 9.63533 7.05208 10.4478C7.86458 11.2603 8.84722 11.6666 10 11.6666ZM7.5 4.99992H12.5C12.5 4.30547 12.2569 3.7152 11.7708 3.22909C11.2847 2.74297 10.6944 2.49992 10 2.49992C9.30556 2.49992 8.71528 2.74297 8.22917 3.22909C7.74306 3.7152 7.5 4.30547 7.5 4.99992Z",
    fill: "#165227"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShops);
export default __webpack_public_path__ + "static/media/shops.0e29d70b8107f9e87e86b9635d73761a.svg";
export { ForwardRef as ReactComponent };